import UserAccount from "../../features/User/UserAccount";

function UserAccountPage() {
    return (
        <UserAccount />
    );
}

export default UserAccountPage;